import produce from 'immer';
import { Reducer } from 'redux';

import { replaceOrAdd, replaceOrAddAdditionalTask } from '@/utils/survey';

import { SurveyActionTypes } from './action-types';
import { initialState } from './constants';
import { SurveyReducerState as State } from './types';

export const surveyReducer: Reducer<State> = (state = initialState, action): State =>
  produce(state, (draft): void => {
    switch (action.type) {
      case SurveyActionTypes.FETCH_SURVEY_ACTIVITY_INFO.START:
        draft.activity = null;
        break;
      case SurveyActionTypes.FETCH_SURVEY_ACTIVITY_INFO.SUCCESS:
        draft.activity = action.payload.activity;
        draft.surveyState = action.payload.siteSurvey;
        break;
      case SurveyActionTypes.UPLOAD_SURVEY_FILE_INIT:
        draft.currentStep.status = 'running';
        draft.currentStep.objUrl = action.payload;
        break;
      case SurveyActionTypes.UPLOAD_SURVEY_FILE_DONE:
        replaceOrAdd(draft.surveyState, action.payload.data, action.payload.subStepId);
        draft.currentStep = {
          objUrl: '',
          progress: 0,
          status: 'success',
          uploadedStepInfo: action.payload.uploadedStepInfo,
        };
        break;
      case SurveyActionTypes.UPLOAD_SURVEY_FILE_CANCEL:
        draft.currentStep = {
          objUrl: '',
          progress: 0,
          status: 'default',
          uploadedStepInfo: 'Something went wrong, please try again.',
        };
        break;
      case SurveyActionTypes.UPLOAD_SURVEY_FILE_FAIL:
        draft.currentStep.progress = 0;
        draft.currentStep.status = 'error';
        draft.currentStep.uploadedStepInfo = 'Please check your connection and try again.';
        break;
      case SurveyActionTypes.UPLOAD_SURVEY_PROGRESS:
        draft.currentStep.progress = action.payload;
        break;
      case SurveyActionTypes.SAVE_ADDITIONAL_SURVEY_TASK.START:
        draft.currentStep.status = 'running';
        break;
      case SurveyActionTypes.SAVE_ADDITIONAL_SURVEY_TASK.SUCCESS:
        // this type o task does not display a success result
        draft.currentStep.status = 'success';
        replaceOrAddAdditionalTask(action.payload, draft.surveyState);
        break;
      case SurveyActionTypes.DELETE_SURVEY_FILE.START:
        draft.currentStep.status = 'deleting';
        break;
      case SurveyActionTypes.DELETE_SURVEY_FILE.SUCCESS:
        draft.currentStep.status = 'deleteSuccess';
        draft.surveyState = draft.surveyState.filter(step => step.id !== action.payload.itemId);
        break;
      case SurveyActionTypes.DELETE_SURVEY_FILE.FAIL:
        draft.currentStep.status = 'deleteError';
        break;
      case SurveyActionTypes.UPLOAD_PHOTO_FAILED:
        draft.currentStep.progress = 0;
        draft.currentStep.status = 'error';
        draft.currentStep.uploadedStepInfo = action.error;
        break;
      default:
        break;
    }
  });
